import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as ApexCharts from 'apexcharts';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
	selector: 'app-email-analytics',
	templateUrl: './email-analytics.component.html',
	styleUrls: ['./email-analytics.component.scss']
})
export class EmailAnalyticsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;
	user_role: any;

	activities_table_header: any = [];

	advisor_manager_header: any = [];
	advisor_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
	afa_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
	assistant_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
	relationship_manager_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
	marketing_team_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
  recruiter_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Description",
			key: "description"
		},
	];

  lending_officer_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];

  insurance_agent_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Stage",
			key: "stage"
		},
		{
			name: "Description",
			key: "description"
		},
	];
	wholeslaer_header: any = [
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Is Opened",
			key: "is_opened"
		},
		{
			name: "Opened Date",
			key: "actual_date"
		},
		{
			name: "Choice",
			key: "choice"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
			this.activities_table_header = this.advisor_manager_header;
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
			this.activities_table_header = this.advisor_header;
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
			this.activities_table_header = this.afa_header;
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
			this.activities_table_header = this.assistant_header;
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
			this.activities_table_header = this.relationship_manager_header;
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Relationship Manager";
			this.activities_table_header = this.marketing_team_header;
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Recruiter";
			this.activities_table_header = this.recruiter_header;
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
			this.activities_table_header = this.wholeslaer_header;
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
			this.activities_table_header = this.lending_officer_header;
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
			this.activities_table_header = this.insurance_agent_header;
		}


		this.changeActionItemDuration(this.action_item_filter_tab_selected);

	}

	action_item_filter_tabs: any = [
		{
			id: 1,
			name: "Day",
			value: "day"
		},
		{
			id: 2,
			name: "Weekly",
			value: "week"
		},
		{
			id: 3,
			name: "Monthly",
			value: "month"
		},
		// {
		// id: 4,
		// 	name: "Quarterly",
		// 	value: "quarter"
		// },
		{
			id: 5,
			name: "Yearly",
			value: "year"
		},
	];
	// action_item_filter_tab_selected: any = {
	// 	id: 1,
	// 	name: "Day",
	// 	value: "day"
	// };
	// action_item_filter_tab_selected: any = {
	// 	id: 3,
	// 	name: "Monthly",
	// 	value: "month"
	// };
	action_item_filter_tab_selected: any = {
		id: 5,
		name: "Yearly",
		value: "year"
	};
	changeActionItemDuration(data) {
		this.action_item_filter_tab_selected = data;
		// this.getPageData();
		this.changeDuration("Selected");
	}

	changeDuration(type) {
		if (type == "Previous") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getPreviousDay();
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getPreviousWeek();
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getPreviousMonth();
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getPreviousYear();
			}
		} else  if (type == "Next") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getNextDay();
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getNextWeek();
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getNextMonth();
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getNextYear();
			}
		} else  if (type == "Selected") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getSelectedDay(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getSelectedWeek(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getSelectedMonth(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getSelectedYear(this.selceted_activity_start_date);
			}
		}
	}

	selceted_activity_start_date: any = new Date();
	selceted_activity_end_date: any = new Date();

	getNextDay() {
		const nextDay = new Date(this.selceted_activity_start_date);
		nextDay.setDate(nextDay.getDate() + 1);
		this.selceted_activity_start_date = nextDay;
		this.selceted_activity_end_date = nextDay;

		this.getPageData();
	}

	getPreviousDay() {
		const previousDay = new Date(this.selceted_activity_start_date);
		previousDay.setDate(previousDay.getDate() - 1);
		this.selceted_activity_start_date = previousDay;
		this.selceted_activity_end_date = previousDay;

		this.getPageData();
	}

	getSelectedDay(date) {
		const currentDate = new Date(date);
		currentDate.setDate(currentDate.getDate());

		this.selceted_activity_start_date = currentDate;
		this.selceted_activity_end_date = currentDate;

		this.getPageData();
	}


	getNextWeek() {
		this.selceted_activity_start_date.setDate(this.selceted_activity_start_date.getDate() + 7);
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	getPreviousWeek() {
		this.selceted_activity_start_date.setDate(this.selceted_activity_start_date.getDate() - 7);
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	getSelectedWeek(date) {
		const modified_date = new Date(date);
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);
		// this.selceted_activity_start_date.setDate(date.getDate());
		this.selceted_activity_start_date.setDate(modified_date.getDate());
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	updateWeekDates(date) {
		const today = new Date(date);
		const dayOfWeek = today.getDay();
		const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
		this.selceted_activity_start_date = new Date(today.setDate(diff));
		this.selceted_activity_end_date = new Date(today.setDate(today.getDate() + 6));

		this.getPageData();
	}

	updateMonthDates(date) {
		const today = new Date(date);

		// this.selceted_activity_start_date = new Date(today.getFullYear(), today.getMonth(), 1);
		// this.selceted_activity_end_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);

		const start_date = new Date(today.getFullYear(), today.getMonth(), 1);
		const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		this.selceted_activity_start_date = moment(start_date).startOf('month').format();
        this.selceted_activity_end_date = moment(end_date).endOf('month').format();

		this.getPageData();
	}

	getNextMonth() {
		this.selceted_activity_start_date.setMonth(this.selceted_activity_start_date.getMonth() + 1);
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getPreviousMonth() {
		this.selceted_activity_start_date.setMonth(this.selceted_activity_start_date.getMonth() - 1);
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getSelectedMonth(date) {
		const modified_date = new Date(date);
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);
		// this.selceted_activity_start_date.setMonth(date.getMonth());
		this.selceted_activity_start_date.setMonth(modified_date.getMonth());
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getNextYear() {
		const nextYear = new Date(this.selceted_activity_start_date);
		nextYear.setFullYear(nextYear.getFullYear() + 1);

		// this.selceted_activity_start_date = nextYear;
		// this.selceted_activity_end_date = nextYear;

		this.selceted_activity_start_date = moment(nextYear).startOf('year').format();
        this.selceted_activity_end_date = moment(nextYear).endOf('year').format();

		this.getPageData();
	}

	getPreviousYear() {
		const previousYear = new Date(this.selceted_activity_start_date);
		previousYear.setFullYear(previousYear.getFullYear() - 1);

		// this.selceted_activity_start_date = previousYear;
		// this.selceted_activity_end_date = previousYear;

		this.selceted_activity_start_date = moment(previousYear).startOf('year').format();
        this.selceted_activity_end_date = moment(previousYear).endOf('year').format();

		this.getPageData();
	}

	getSelectedYear(date) {
		const currentYear = new Date(date);
		currentYear.setFullYear(currentYear.getFullYear());

		// this.selceted_activity_start_date = currentYear;
		// this.selceted_activity_end_date = currentYear;

		this.selceted_activity_start_date = moment(currentYear).startOf('year').format();
        this.selceted_activity_end_date = moment(currentYear).endOf('year').format();

		this.getPageData();
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
		  return null;
		}
		if (num === 0) {
		  return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		  k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		  c =
			k < 1
			  ? num.toFixed(0 + fixed)
			  : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		  d = c < 0 ? c : Math.abs(c),
		  e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	page_data: any;
	page_data_loaded: boolean = false;

	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;

	show_search: boolean = false;
	search_key: any = '';

	table_data_loaded: boolean = false;
	getPageData() {

		this.show_activity_view = null;

		// this.page_data_loaded = false;

		this.table_data_loaded = false;

		let route: any = "";

		if (this.user_details.role.role == 4) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 5) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 6) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 7) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 8) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 11) {
			route = "/mtmailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 10) {
			route = "/recruitermailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 12) {
			route = "/wholesalermailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 13) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		} else if (this.user_details.role.role == 14) {
			route = "/mailanalytics/?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search="  + this.search_key;
		}

		route = route + "&start_date=" + this.datePipe.transform(this.selceted_activity_start_date, 'yyyy-MM-dd');
		route = route + "&end_date=" + this.datePipe.transform(this.selceted_activity_end_date, 'yyyy-MM-dd');

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_data = res['data'];
				// this.filtered_data = [...this.page_data.total_records_table];

				this.total_pagination_records = this.page_data['total_no_of_records'];

				this.page_data_loaded = true;
				this.toggleGraphs();

				this.table_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	show_graphical_representation: boolean = false;
	toggleGraphs() {
		if (this.show_graphical_representation == true) {
			setTimeout(() => {
				this.createYearlyTrendsGraph();
				this.createResponsesGraph();
				this.createOpenClickGraph();
			}, 200);
		}
	}

	createYearlyTrendsGraph() {
		let $this = this;
		var options = {
			colors: this.page_data['yearly_trends']['colors'],
			series: this.page_data['yearly_trends']['y-axis'],
			chart: {
				height: 300,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
			},
			stroke: {
				curve: 'smooth',
				width: 2
			},
			fill: {
				type: 'solid',
				opacity: [0.5, 1],
			},
			labels: this.page_data['yearly_trends']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// let val: string | number = Math.abs(value);
					// if (val >= 10 ** 3 && val < 10 ** 6) {
					// 	val = (val / 1000).toFixed(0) + 'K';
					// } else if (val >= 10 ** 6) {
					// 	val = (val / 1000000).toFixed(0) + 'M';
					// } else {
					// 	val = val;
					// }
					// return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
				},
				// {
				//   opposite: true,
				//   title: {
				//     text: '',
				//   },
				// },
			],
			// tooltip: {
			//   shared: true,
			//   intersect: false,
			//   y: {
			//     formatter: function (y) {
			//       if(typeof y !== "undefined") {
			//         return  y.toFixed(0) + " points";
			//       }
			//       return y;
			//     }
			//   }
			// }
		};
		var chart = new ApexCharts(document.querySelector('#yearly-trends-graph'), options);
		chart.render();
	}

	createResponsesGraph() {
		let $this = this;
		var options = {
			colors: $this.page_data['yearly_responses']['colors'],
			series: $this.page_data['yearly_responses']['y-axis'],
			// series: [
			// 	{
			// 		name: '',
			// 		data: $this.page_data['yearly_responses']['y-axis'],
			// 	},
			// ],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
			zoom: {
				enabled: false,
			},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('responses-graph').clientWidth,
					$this.page_data['yearly_responses']['x-axis'].length,
					30,
					),
					endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_data['yearly_responses']['x-axis'],
				title: {
					// text: 'Years'
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// let val: string | number = Math.abs(value);
					// if (val >= 10 ** 3 && val < 10 ** 6) {
					// 	val = (val / 1000).toFixed(0) + 'K';
					// } else if (val >= 10 ** 6) {
					// 	val = (val / 1000000).toFixed(0) + 'M';
					// } else {
					// 	val = val;
					// }
					// return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (val) {
					return val;
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#responses-graph'), options);
		chart.render();
	}

	createOpenClickGraph() {
		let $this = this;
		var options = {
			colors: ["#7958FF"],
			series: $this.page_data['opened_ratio_graph']['data'],
			chart: {
				height: 355,
				type: 'radialBar',
			},
			plotOptions: {
				radialBar: {
					dataLabels: {
						hollow: {
							size: '80%',
						},
						name: {
							fontSize: '22px',
							color: "#7958FF",
						},
						value: {
							fontSize: '16px',
							color: "#7958FF",
						},
						total: {
							show: true,
							label: $this.page_data['opened_ratio_graph']['labels'][0],
							formatter: function (w) {
								// By default this function returns the average of all series.
								return $this.page_data['opened_ratio_graph']['data'][0] + "%";
							}
						}
					},
					track: {
						background: '#e1e9f3'
					  }
				}
			},
			labels: $this.page_data['opened_ratio_graph']['labels'],
		};

		var chart = new ApexCharts(document.querySelector("#open-click-graph"), options);
		chart.render();
	}

	show_user_profile: any = "";
    user_profile_data: any;
    showUserProfile(data, type) {
      this.user_profile_data = JSON.parse(JSON.stringify(data));
      this.show_user_profile = JSON.parse(JSON.stringify(type));;
    }

    profileClosed(event) {
      this.user_profile_data = {};
      this.show_user_profile = "";
    }





	filtered_data: any = [];
	searchClients() {
		if (this.search_key) {
			this.filtered_data = this.page_data.total_records_table.filter(item => (item['full_name'] != undefined && item['full_name'].toString().toLowerCase()).includes(this.search_key.toLowerCase()));
		} else {
			this.filtered_data = [...this.page_data.total_records_table];
		}
	}

	pageChanged(event) {

		this.show_activity_view = null;

		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;

		this.table_data_loaded = false;
		this.getPageData();
	}

	show_activity_view: number = null;
	toggleActivityView(value) {
		if (this.show_activity_view == value) {
			this.show_activity_view = null;
		} else {
			this.show_activity_view = value;
		}
	}

	activityDetailsUpdated(event) {
		this.getPageData();
	}


}
